import {http, httpCustom} from './config';
import {httpAuth} from './config';

export default {
    register: (user) => {
        return httpAuth.post('v1/oauth/register', user);
    },
    getCompaniesUser: (userId, token = null) => {
        if (token){
            return httpAuth.get(`api/company/user/${userId}?onlyCompany=true`,{
                headers:{
                    Authorization: `Bearer ${token}`
                }});
        }
        return httpAuth.get(`api/company/user/${userId}?onlyCompany=true`);
    },
    indexUserOnOauth:(filter, page) => {
        return httpAuth.get(`api/external/user?page=${page}`, {params:filter});
    },
    alterCompanyPermissionsUser:(token, destiny) => {
        return httpAuth.get(`api/r2-security/auth/token/${token}?alterCompanyForUser=${JSON.stringify(destiny)}`);
    },
    security: (token) => {
        return httpAuth.get(`api/r2-security/auth/token/${token}`);
    },
    login: (user) => {
        return httpAuth.post('v1/oauth/token', user);
    },
    authUser: (user) => {
        return httpAuth.post('api/v1/oauth/auth', user);
    },
    loadSession: (token) => {
        return httpAuth.get('api/external/auth/check/token', token);
    },
    refreshToken: (token) => {
        return httpAuth.get(`api/r2-security/auth/token/${token}/refresh`);
    },
    refreshTokenCustom: (token) => {
        return httpAuth.get(`api/r2-security/auth/token/${token}/refresh?custom=true`);
    },
    google: (googleUser) => {
        return httpAuth.get('login/google/callback', {params: googleUser});
    },
    listRealtor: (allotment_id, custom = false) => {
        if (custom){
            return httpCustom.get('api/v1/loteamentos/corretores/' + allotment_id);
        }
        return http.get('api/v1/loteamentos/corretores/' + allotment_id);
    },
    permissions: (allotment_id) => {
        return http.get('api/v1/usuarios/permissao/' + allotment_id);
    },
    create: (user) => {
        return http.post('api/v1/usuarios', user);
    },
    createPublic: (user, allotmentId, token) => {
        return http.post('api/v1/publica/usuario', user, {headers: {'allotment-id': allotmentId, token: token}});
    },
    show: (user_id) => {
        return httpAuth.get('api/external/user/' + user_id);
    },
    update: (user) => {
        return http.put('api/v1/usuarios/dados-pessoais/' + user.id, user);
    },
    showByCompanyWithoutPaginate: (companyId) => {
        return httpAuth.get(`v1/oauth/showPorEmpresa/${companyId}`);
    },
    showByCompany: (companyId, filter, page = 1) => {
        return httpAuth.get('v1/usuarios/companhia/' + companyId + '?page=' + page, {params: {'filtro': filter}});
    },
    recoverPassword: (email) => {
        return httpAuth.post('api/external/user/email/sendResetPassword', email);
    },
    resetPassword: (password) => {
        return httpAuth.post('v1/password/reset', password);
    },
    resetPasswordLogged: (dates) => {
        return httpAuth.put('api/external/user/update-password', dates);
    },
    sendEmailRegister: (email) => {
        return httpAuth.post('v1/password/email/first', email);
    },
    listPhoneType: () => {
        return httpAuth.get('v1/usuarios/tipoTelefones');
    },
    listAll: () => {
        return http.get('api/v1/usuarios');
    },
    validateToken: (token, mail) => {
        return httpAuth.post('v1/password/reset/validate-token', {token: `${token}/${mail}`});
    },
    validateTokenPublicUser: (token, allotmentId) => {
        return http.post('api/v1/publica/usuarios/checklinkpublico', {}, {
            headers: {
                token: token,
                'allotment-id': allotmentId
            }
        });
    },
    import: (file, allotment_id, notify = false) => {
        const formData = new FormData();
        formData.append('file', file);
        return http.post('api/v1/importar/usuarios', formData, {
            headers: {
                'allotment-id': allotment_id,
                'Content-Type': 'multipart/form-data',
                notify,
            }
        });
    },
    exportUsersAlotment: allotmentId => http.get(`api/v1/exportar/corretores/${allotmentId}`, {responseType: 'blob'}),
}
